// Shared formatting & semaforización helpers
export const STATUS_META = {
  verde: { label: "En meta", color: "hsl(var(--success))", bg: "bg-success/10", text: "text-success", border: "border-success/30", dot: "bg-success", head: "bg-success" },
  amarillo: { label: "En riesgo", color: "hsl(var(--warning))", bg: "bg-warning/10", text: "text-warning", border: "border-warning/30", dot: "bg-warning", head: "bg-warning" },
  rojo: { label: "Fuera de meta", color: "hsl(var(--danger))", bg: "bg-danger/10", text: "text-danger", border: "border-danger/30", dot: "bg-danger", head: "bg-danger" },
  sin_datos: { label: "Sin datos", color: "hsl(var(--muted-foreground))", bg: "bg-muted", text: "text-muted-foreground", border: "border-border", dot: "bg-muted-foreground", head: "bg-muted-foreground" },
};

export const SOURCE_META = {
  manual: { label: "Manual", text: "text-info", bg: "bg-info/10", border: "border-info/30" },
  odoo: { label: "Odoo", text: "text-warning", bg: "bg-warning/10", border: "border-warning/30" },
  mixto: { label: "Mixto", text: "text-success", bg: "bg-success/10", border: "border-success/30" },
};

export function formatValue(value, unit) {
  if (value === null || value === undefined) return "—";
  const isMoney = unit && unit.includes("MXN");
  if (isMoney) {
    return new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 }).format(value);
  }
  return new Intl.NumberFormat("es-MX", { maximumFractionDigits: 3 }).format(value);
}

export function formatPeriod(p) {
  if (!p) return "—";
  const [y, m] = p.split("-");
  const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
  return `${months[parseInt(m, 10) - 1]} ${y}`;
}
